import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class AssignLeadErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: [{
                code: 'lead_already_assigned',
                text: 'El lead ya fue asignado',
            }],
        };
    }

    static errorCodes() {
        return ['lead_already_assigned', 'lead_responsible_is_neither_a_closer_nor_the_assigner'];
    }
}
